// Our Footer component
// Thsi will need to be modified to match the JSX coming from webflow
import React from "react";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";

function Footer() {
  // Accessing data.
  const { data } = useSelector((state) => state.cms);
  const singleTypeSlug = "footer";
  const cmsData = data[singleTypeSlug] && data[singleTypeSlug].attributes;

  // Only load if data has returned.
  if (!cmsData) return null;
  return (
    <div className="section footer wf-section">
      <div className="containerfooter w-container">
        <div className="footerdiv">
          <div className="textcenter">
            <img
              src={cmsData.logo.data && cmsData.logo.data.attributes.url}
              loading="lazy"
              width={122}
              alt="The Royal Canadian Air Cadets' logo."
            />

            {/* Render Logos */}
            <div className="divfooterlogos">
              {cmsData.socialMediaIcons &&
                cmsData.socialMediaIcons.map((item) => {
                  return (
                    <a
                      href={item.url}
                      target="_blank"
                      className="w-inline-block"
                      rel="noreferrer"
                      key={uuid()}
                    >
                      <img
                        src={item.icon.data && item.icon.data.attributes.url}
                        loading="lazy"
                        alt={item.icon.data.alt}
                        className="socialmediaicon"
                      />
                    </a>
                  );
                })}
            </div>
          </div>
        </div>

        {/* Credit and Attributions*/}
        <div className="divcredit">
          <a
            href={cmsData.civiconnectURL}
            target="_blank"
            className="divfooterlogos w-inline-block"
            rel="noreferrer"
          >
            <img
              src={cmsData.cLogo.data && cmsData.cLogo.data.attributes.url}
              loading="lazy"
              alt="Powered by Civiconnect logo!"
              className="civiconnectlogo"
            />
          </a>

          {cmsData.attributions &&
            cmsData.attributions.map((item) => {
              return (
                <a
                  href={item.url}
                  target="_blank"
                  className="linkcredit"
                  rel="noreferrer"
                  key={uuid()}
                >
                  {item.text}
                </a>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default Footer;
